import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import {
  IGetExercisesApiParams,
  IGetExercisesApiResponse,
  IUpdateExercisesApiParams,
  IUpdateExercisesApiResponse,
} from "./exercises.types";

export const exercisesApi = createApi({
  reducerPath: "exercisesApi",
  baseQuery: httpService({
    baseUrl: `/api/v1/user/info/exercises`,
  }),
  tagTypes: ["exercisesData"],
  endpoints: (build) => ({
    getExercises: build.query<IGetExercisesApiResponse, IGetExercisesApiParams>(
      {
        query: ({ lessonId }) => ({
          url: `/${lessonId}/`,
          method: "get",
        }),
        providesTags: () => ["exercisesData"],
      },
    ),
    updateExercises: build.mutation<
      IUpdateExercisesApiResponse,
      IUpdateExercisesApiParams
    >({
      query: ({ exerciseId, params }) => ({
        url: `/${exerciseId}/`,
        method: "put",
        data: params,
      }),
    }),
  }),
});

export const {
  useGetExercisesQuery,
  useLazyGetExercisesQuery,
  useUpdateExercisesMutation,
} = exercisesApi;
